import React, { useEffect, useState } from 'react';
import { Wine, Building2, Award } from 'lucide-react';
import { getCollaborators, resolveImg } from '../lib/api';
import { useSettings } from '../lib/SettingsContext';

import { useLang } from '../lib/i18n';
export default function Colaboradores() {
  const { ui } = useLang();
  const { settings } = useSettings();
  const [collabs, setCollabs] = useState([]);
  useEffect(() => { getCollaborators().then(setCollabs).catch(() => {}); }, []);
  const bodegas = collabs.filter((c) => c.category === 'bodega');
  const partners = collabs.filter((c) => c.category === 'partner');
  const sponsors = collabs.filter((c) => c.category === 'sponsor');
  const heroImg = resolveImg(settings.hero_images?.[1] || settings.hero_images?.[0] || '');

  const renderCollab = (c) => (
    <div key={c.id} className="gd-card aspect-[4/3] flex flex-col items-center justify-center text-center px-4">
      {c.logo ? (
        <img src={resolveImg(c.logo)} alt={c.name} className="max-h-16 max-w-[80%] object-contain mb-3" />
      ) : (
        <Wine size={28} className="text-[#c9a063]/40 mb-3" />
      )}
      <div className="font-serif-display text-white text-lg leading-tight">{c.name}</div>
      {c.subtitle && <div className="text-[10px] tracking-widest text-[#c9a063] mt-2 uppercase">{c.subtitle}</div>}
    </div>
  );

  return (
    <div>
      <section className="relative h-[55vh] min-h-[400px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 gd-hero-bg" style={{ backgroundImage: `url(${heroImg})` }} />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, rgba(13,13,14,0.6), rgba(13,13,14,0.95))' }} />
        <div className="relative z-10 text-center px-6">
          <div className="gd-eyebrow mb-3">{ui('partners.eyebrow')}</div>
          <h1 className="font-script text-[#c9a063] text-5xl md:text-7xl leading-none">{ui('partners.title')}</h1>
          <p className="font-serif-display text-white text-2xl md:text-3xl mt-4">{ui('partners.sub')}</p>
        </div>
      </section>

      <section className="py-20 px-6 md:px-10 bg-[#0d0d0e]">
        <div className="max-w-6xl mx-auto space-y-20">
          {bodegas.length > 0 && (
            <div>
              <div className="flex items-center gap-3 mb-8">
                <Wine size={20} className="text-[#c9a063]" />
                <h2 className="font-serif-display text-3xl md:text-4xl text-white">{ui('home.wineries')}</h2>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">{bodegas.map(renderCollab)}</div>
            </div>
          )}
          {partners.length > 0 && (
            <div>
              <div className="flex items-center gap-3 mb-8">
                <Building2 size={20} className="text-[#c9a063]" />
                <h2 className="font-serif-display text-3xl md:text-4xl text-white">{ui('home.other_partners')}</h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">{partners.map(renderCollab)}</div>
            </div>
          )}
          {sponsors.length > 0 && (
            <div>
              <div className="flex items-center gap-3 mb-8">
                <Award size={20} className="text-[#c9a063]" />
                <h2 className="font-serif-display text-3xl md:text-4xl text-white">{ui('home.sponsors')}</h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">{sponsors.map(renderCollab)}</div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
